import {
  getGetEntityMicrositePublicLinkQueryKey,
  useGetEntityMicrositePublicLink
} from '@cdf/api-client-react';

import { useTenantEntity } from '@/components/access/tenant-entity-provider';
import { publicMicrositeUrl } from '@/components/microsites/microsite-model';

export function usePublicMicrositeLink() {
  const access = useTenantEntity();
  const entityId = access.selected?.entityId ?? '';
  const enabled = access.selected !== null;
  const query = useGetEntityMicrositePublicLink(entityId, {
    query: {
      queryKey: getGetEntityMicrositePublicLinkQueryKey(entityId),
      enabled,
      retry: 1,
      staleTime: 30_000
    }
  });
  const microsite = query.data;
  const publicUrl = microsite?.isPublished ? microsite.publicUrl : null;
  const url = publicUrl && microsite
    ? publicUrl.startsWith('/')
      ? publicMicrositeUrl(microsite)
      : publicUrl
    : null;

  return {
    url,
    isPublished: Boolean(query.data?.isPublished && url),
    isLoading: enabled && query.isPending
  };
}
